import { Builder } from "@builder.io/react";
import React from "react";
import BuilderStringInput from "@utils/BuilderInputs/BuilderStringInput";
import BuilderImageInput from "@utils/BuilderInputs/BuilderImageInput";
import EmailCapture from "@components/Shortcodes/EmailCapture/EmailCapture";

type EmailCaptureWBackgroundPropsType = {
  cta: string;
  emailPlaceholder: string;
  headline: string;
  background: string;
};

const EmailCaptureWBackground: React.FC<EmailCaptureWBackgroundPropsType> = ({
  cta,
  emailPlaceholder,
  headline,
  background,
}) => {
  return (
    <>
      <EmailCapture
        emailCaptureBg={background || "/images/green_bg.webp"}
        emailCaptureCopy={headline || "Sign up for emails from SimplePractice"}
        emailCaptureCtaText={cta || "Sign up"}
        articleTitle=""
        emailPlaceholder={emailPlaceholder}
        builderComponent
      />
    </>
  );
};

export default EmailCaptureWBackground;

export const RegisterEmailCaptureWBackground = () => {
  Builder.registerComponent(EmailCaptureWBackground, {
    name: "email-capture-background",
    inputs: [
      new BuilderStringInput("headline", {
        defaultValue: "Sign up for emails from SimplePractice",
      }),
      new BuilderStringInput("emailPlaceholder", { defaultValue: "Email" }),
      new BuilderStringInput("cta", { defaultValue: "Sign up" }),
      new BuilderImageInput("background"),
    ],
  });
};
